export const Help = axios => ({
  // Submit the Help Center "Contact us" form (RT-10216).
  // Endpoint is profile-scoped; `slug` is the candidate's profile slug.
  // The XSystemType header is set globally in api/index.js.
  contactSupport(slug, payload) {
    return axios.post(`/v1/profiles/${slug}/contact-form`, payload)
  }
})
